module.exports = __webpack_public_path__ + "static/media/gc.1b62a2e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/gc.png
// module id = 683
// module chunks = 0